import { BaseObject } from "./BaseObject";

/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

export class Plan extends BaseObject {

    id: number;

    precio: number;
    minimoComprobantes: number;
    maximoComprobantes: number;
    tipo: string;
    publico: boolean;
    colegiado: boolean;
    visibleWeb: boolean;
    visiblePrecio: boolean;
    tipoPlan: string;
} 